module.exports = "img/flags/SK.af77361.png";